import React from "react";
import { Card, Inline, Text, TrackedLink } from "@origin-digital/ods-core";
import styled from "styled-components";
import { IconStar } from "@origin-digital/ods-icons";
import { trackClick } from "../../helpers/tracking";

type Props = {
  category?: string;
  title: string;
  trackingUrl: string;
  href: string;
  subtitle: string | null;
};

const UnstyledTrackedLink = styled(TrackedLink)`
  text-decoration: none;
`;

const RecommendedChipContainer = styled("div")`
  background-color: ${({ theme }) =>
    theme.palette.mode === "light"
      ? "#ffc72c"
      : theme.palette.backgroundColor.promoteD.main};
  width: fit-content;
  padding: 2px 6px;
  border-radius: 4px;

  svg {
    font-size: 16px;
  }
`;

const RecommendedCard = styled(Card)`
  display: grid;
  gap: ${({ theme }) => theme.space.small}px;
  padding: 16px;
`;

const ResultCard = ({ category, title, subtitle }: Props) => (
  <div>
    {category && (
      <Text variant="body-small" tone="neutralLight" weight="medium">
        {category}
      </Text>
    )}
    <Text
      data-id="result-title"
      variant="subtitle-small"
      weight="medium"
      tone="neutralDark"
    >
      {title}
    </Text>
    <Text data-id="result-subtitle" tone="neutral">
      {subtitle}
    </Text>
  </div>
);

export const SearchResult = (props: Props) => {
  return (
    <UnstyledTrackedLink
      data-id="search-result"
      href={props.href}
      onClick={() => trackClick(props.trackingUrl)}
      trackingLabel="search-result"
      trackingType="ResultLink"
    >
      <ResultCard {...props} />
    </UnstyledTrackedLink>
  );
};

export const RecommendedSearchResult = (props: Props) => {
  return (
    <UnstyledTrackedLink
      data-id="recommended-result"
      href={props.href}
      onClick={() => trackClick(props.trackingUrl)}
      trackingLabel="recommended-search-result"
      trackingType="RecommendedLink"
    >
      {/* @ts-ignore ods types don't like this background color */}
      <RecommendedCard padding="small" backgroundColor="#fffbee">
        <RecommendedChipContainer>
          <Inline alignY="center" space="xxsmall">
            <IconStar size="small" color="neutralDark" />
            <Text tone="neutralDark" variant="body-small" weight="medium">
              Recommended
            </Text>
          </Inline>
        </RecommendedChipContainer>
        <ResultCard {...props} />
      </RecommendedCard>
    </UnstyledTrackedLink>
  );
};
